import React, { createContext, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

const LocaleContext = createContext();

const { Consumer: LocaleConsumer, Provider: LocaleProvider } = LocaleContext;

export const useLocale = () => useContext(LocaleContext);

export const connectToLocale = (PassedComponent) => {
  function Component(props) {
    return (
      <LocaleConsumer>
        {(context) => {
          if (!context) {
            throw new Error(`
            connectToLocale does not have a context prop. This means
            that you either haven't included a <Locale> component in your project structure
            or you didn't pass it a context
          `);
          }
          return <PassedComponent {...props} context={context} />
        }}
      </LocaleConsumer>
    );
  }

  Component.WrappedComponent = PassedComponent;
  return hoistNonReactStatics(Component, PassedComponent);
};

export const Locale = LocaleProvider;
